import { Location } from "@angular/common";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { iconsLibrary } from "../../../theme/constants";
import { EButtonType } from "../../data-types/button.enum";
import { ECoworkerView } from "../../data-types/coworker.enums";
import { EFooterStyleInput } from "../../data-types/footer.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { EActiveTab } from "../../data-types/tabs.enum";
import { CoworkerService } from "../../services/coworker.service";
import { CoworkingService } from "../../services/coworking.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { CoworkerBookingCardComponent } from "../shared/coworker-booking-card/coworker-booking-card.component";
import { UserService } from "../../services/user.service";
import { showAlertAction } from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import * as moment from "moment";
import { StateService } from "../../services/state.service";
import { FormBuilder, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "cowing-core-coworker-info",
  templateUrl: "./coworker-info.component.html",
  styleUrls: ["./coworker-info.component.scss"],
})
export class CoworkerInfoComponent implements OnInit {
  private tokenRefreshed = false;
  private bookingToDelete;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;
  public EActiveTab = EActiveTab;
  public coworkerInfo = null;

  public showCancelBookingSection = false;

  public coworkerInfoForm = this.formBuilder.group({
    cp: new FormControl({ value: null, disabled: false }, [
      Validators.required,
    ]),
    current_cowings: new FormControl({ value: null, disabled: true }, [
      Validators.required,
    ]),
    email: new FormControl({ value: null, disabled: true }, [
      Validators.required,
    ]),
    employee_id: new FormControl({ value: null, disabled: true }),
    language: new FormControl({ value: null, disabled: false }, [
      Validators.required,
    ]),
    name: new FormControl({ value: null, disabled: false }, [
      Validators.required,
    ]),
    total_cowings: new FormControl({ value: null, disabled: true }, [
      Validators.required,
    ]),
  });

  constructor(
    private _store: Store<IAppState>,
    private _router: Router,
    private _location: Location,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private localStorageService: LocalStorageService
  ) {}
  async ngOnInit() {
    this._store.dispatch(showLoadingAction({}));
    const coworkerId = LocalStorageService.instance.get(EStorageType.Coworker);
    try {
      const response = await CoworkerService.instance.getCoworkerInfo(
        coworkerId
      );
      this.coworkerInfoForm.patchValue(response);
      this.coworkerInfo = response;
    } catch (e) {
      if (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      }
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  get getCalendarIcon() {
    return `${iconsLibrary.calendarEmpty}`;
  }

  public navigateTo(link) {
    this._router.navigate([`${link}`]);
  }

  public get getClose() {
    return `${iconsLibrary.closeSimple}`;
  }

  public goBack() {
    return this.navigateTo("coworker-profile");
  }
  showCancel(event?) {
    this.showCancelBookingSection = !this.showCancelBookingSection;
    if (event) {
      this.bookingToDelete = event;
    } else {
      this.bookingToDelete = null;
    }
  }
  public async editCoworker() {
    try {
      this._store.dispatch(showLoadingAction({}));
      const coworkerId = LocalStorageService.instance.get(
        EStorageType.Coworker
      );
      const payload = {
        cp: this.coworkerInfoForm.getRawValue().cp,
        current_cowings: this.coworkerInfoForm.getRawValue().current_cowings,
        email: this.coworkerInfoForm.getRawValue().email,
        employee_id: this.coworkerInfoForm.getRawValue().employee_id,
        language: this.coworkerInfoForm.getRawValue().language.id,
        name: this.coworkerInfoForm.getRawValue().name,
        total_cowings: this.coworkerInfoForm.getRawValue().total_cowings,
      };
      const changeBooking = await CoworkerService.instance.putCoworkerInfo(
        coworkerId,
        payload
      );
      const lang = this.coworkerInfoForm
        .getRawValue()
        .language.id.split("_")[0];
      this.translate.use(lang);
      this.translate.setDefaultLang(lang);
      this.localStorageService.set(EStorageType.Language, lang);
    } catch (e) {
      if (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      }
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  get arrowLeftIcon() {
    return `${iconsLibrary.arrowLeft}`;
  }
}
